import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BeaconError, BeaconErrorType } from '..';
/**
 * @category Error
 */

export var NetworkNotSupportedBeaconError = /*#__PURE__*/function (_BeaconError) {
  _inherits(NetworkNotSupportedBeaconError, _BeaconError);

  var _super = _createSuper(NetworkNotSupportedBeaconError);

  function NetworkNotSupportedBeaconError() {
    var _this;

    _classCallCheck(this, NetworkNotSupportedBeaconError);

    _this = _super.call(this, BeaconErrorType.NETWORK_NOT_SUPPORTED, 'The wallet does not support this network. Please select another one.');
    _this.name = 'NetworkNotSupportedBeaconError';
    _this.title = 'Network Error';
    return _this;
  }

  return _createClass(NetworkNotSupportedBeaconError);
}(BeaconError);